<div class="tabs component-container-edge">
  <ul class="tablist" role="tablist">
    <li role="presentation">
      <a
        id="tab-{{ FLU_CAMPAIGN_ID }}"
        class="tab"
        role="tab"
        href="{`#tabpanel-${uid}`}"
        [attr.aria-controls]="'tabpanel-' + FLU_CAMPAIGN_ID"
        [attr.aria-selected]="selectedTabId === FLU_CAMPAIGN_ID"
        (click)="onTabClick($event, FLU_CAMPAIGN_ID)">
        Flu
      </a>
    </li>
    <li role="presentation">
      <a
        id="tab-{{ COVID_CAMPAIGN_ID }}"
        class="tab"
        role="tab"
        href="{`#tabpanel-${uid}`}"
        [attr.aria-controls]="'tabpanel-' + COVID_CAMPAIGN_ID"
        [attr.aria-selected]="selectedTabId === COVID_CAMPAIGN_ID"
        (click)="onTabClick($event, COVID_CAMPAIGN_ID)">
        Covid
      </a>
    </li>
  </ul>

  @if (selectedTabId === FLU_CAMPAIGN_ID) {
    <section
      class="tabpanel greeting"
      role="tabpanel"
      id="tabpanel-{{ FLU_CAMPAIGN_ID }}"
      [attr.aria-labelledby]="'tab-' + FLU_CAMPAIGN_ID">
      <div class="main-container">
        <h2 class="greet-container greeting__title">{{ fluHeader?.title }}</h2>
      </div>
    </section>
  }

  @if (selectedTabId === COVID_CAMPAIGN_ID) {
    <section class="greeting tabpanel" role="tabpanel" id="tabpanel-{{ COVID_CAMPAIGN_ID }}">
      <div class="main-container">
        <div class="greet-container covid-hero">
          <h2 class="greeting__title">{{ covidHeader?.title }}</h2>
          <p class="greeting__link">
            Please monitor the Infonet's
            <ods-link href="https://infonet.upmc.com/infonet/ls/content/6815407425605093/covid-19" target="_blank" variant="inline">
              COVID-19 Vaccine Page
            </ods-link>
            for the latest information on compliance and mandates
          </p>
        </div>
      </div>
    </section>
  }
</div>

<router-outlet></router-outlet>
